<template>
  <div
    class="navbar-signin-popover position-relative d-inline-block"
    @mouseenter="show = true"
    @mouseleave="show = false"
  >
    <span class="text-app cursor-pointer px-2 py-1">
      Hola, <span class="fw-semibold">identifícate</span>
    </span>
    <div v-if="show" class="signin-popover shadow rounded-3 p-4">
      <button class="btn btn-primary-app w-100 mb-2 fw-bold fs-5" @click="goToLogin">
        Identifícate
      </button>
      <div class="text-app text-center small">
        ¿Eres un cliente nuevo?
        <a class="ms-1" @click.prevent="goToSignup" href="#">Empieza aquí</a>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'

const show = ref(false)
const router = useRouter()

function goToLogin() {
  router.push({ name: 'login' })
}
function goToSignup() {
  router.push({ name: 'signUp' })
}
</script>

<style scoped>
.navbar-signin-popover {
  min-width: 160px;
}
.navbar-signin-text {
  font-size: 1rem;
  color: #222;
}
.signin-popover {
  position: absolute;
  top: 120%;
  left: 50%;
  transform: translateX(-50%);
  background: #fff;
  z-index: 1000;
  min-width: 250px;
  border: 1px solid #eee;
  transition: box-shadow 0.2s;
}
.signin-popover .btn-primary {
  background: #f16322;
  border: none;
}
.signin-popover a {
  color: #f16322;
  text-decoration: underline;
  cursor: pointer;
}
</style>
